// extracted by mini-css-extract-plugin
export var Header = "Header-module--Header--P8nKI";
export var OpenMenu = "Header-module--OpenMenu--zc9eq";
export var Light = "Header-module--Light--awWPB";
export var Menu = "Header-module--Menu--oG2JO";
export var Active = "Header-module--Active--+QTIC";
export var Lang = "Header-module--Lang--cV--p";
export var Chevron = "Header-module--Chevron--Vaji6";
export var ContactUs = "Header-module--ContactUs--IrICT";
export var BurgerLine = "Header-module--BurgerLine--BsjrJ";
export var DropDown = "Header-module--DropDown--kxXeP";
export var ActiveParent = "Header-module--ActiveParent--yjGLr";
export var Logo = "Header-module--Logo--t6cP6";
export var Burger = "Header-module--Burger--t2ezQ";
export var LinkWrap = "Header-module--LinkWrap--CAdAi";
export var Overlay = "Header-module--Overlay--su5n4";
export var IsParent = "Header-module--IsParent--8O6-k";
export var HeaderSettings = "Header-module--HeaderSettings--FEe5p";
export var LangWrap = "Header-module--LangWrap--aul8Q";
export var LangDropDown = "Header-module--LangDropDown--xZv8n";
export var LangDropDownOpen = "Header-module--LangDropDownOpen--J6lKr";
export var LangOption = "Header-module--LangOption--UybBC";
export var LangOptionActive = "Header-module--LangOptionActive--5FP0v";
export var FlagIcon = "Header-module--FlagIcon--xfbUx";
export var ChevronOpen = "Header-module--ChevronOpen--txXbR";
export var arrowLeft = "Header-module--arrowLeft--hB-Wl";
export var arrowRight = "Header-module--arrowRight--fGs3G";